import { Briefcase, ShoppingCart, ShieldCheck, Map, TrendingUp, Dumbbell, Megaphone, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/api";

const ICONS = { Briefcase, ShoppingCart, ShieldCheck, Map, TrendingUp, Dumbbell, Megaphone };

const ACCENT = {
  cyan: "text-neon-cyan border-neon-cyan/40 shadow-[0_0_30px_rgba(0,255,255,0.15)]",
  orange: "text-neon-orange border-neon-orange/40 shadow-[0_0_30px_rgba(255,94,0,0.15)]",
  lime: "text-neon-lime border-neon-lime/40 shadow-[0_0_30px_rgba(57,255,20,0.15)]",
  pink: "text-neon-pink border-neon-pink/40 shadow-[0_0_30px_rgba(255,0,127,0.15)]",
};

// Bento layout: first card large
const SPANS = [
  "md:col-span-8 md:row-span-2",
  "md:col-span-4",
  "md:col-span-4 md:row-span-2",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4",
];

export default function Services({ onSelectService }) {
  return (
    <section id="ventures" data-testid="services-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="overline mb-4">// THE_PORTFOLIO</div>
            <h2 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter">
              Seven ventures.<br />
              <span className="text-white/40">One operator.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-base md:text-lg">
            Each one stands on its own — proven, profitable, and built with care. <span className="text-white">Choose where you want to start. We'll meet you there.</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6 auto-rows-[minmax(180px,auto)]">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            const accent = ACCENT[s.accent] || ACCENT.cyan;
            const isLarge = i === 0;
            return (
              <button
                key={s.id}
                onClick={() => onSelectService?.(s.name)}
                data-testid={`service-card-${s.id}`}
                className={`group relative glass glass-hover text-left p-7 md:p-8 ${SPANS[i]} flex flex-col justify-between overflow-hidden transition-all hover:-translate-y-1 hover:${accent}`}
              >
                <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-current opacity-0 group-hover:opacity-5 blur-3xl transition-opacity duration-500" />

                <div className="flex items-start justify-between relative z-10">
                  <div className={`w-12 h-12 flex items-center justify-center border ${accent} bg-black/30`}>
                    <Icon size={22} strokeWidth={1.5} />
                  </div>
                  <ArrowUpRight
                    size={20}
                    className="text-white/30 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
                  />
                </div>

                <div className="relative z-10 mt-6">
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mb-3">
                    // {String(i + 1).padStart(2, "0")} — {s.tag}
                  </div>
                  <h3 className={`font-heading font-bold tracking-tight mb-3 ${isLarge ? "text-3xl md:text-4xl" : "text-xl md:text-2xl"}`}>
                    {s.name}
                  </h3>
                  <p className={`text-white/60 ${isLarge ? "text-base md:text-lg max-w-xl" : "text-sm"}`}>
                    {s.desc}
                  </p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
